import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor() { }

  logoutUser() {
    confirm("Are you sure you want to logout?")
    localStorage.clear();
    this.logoutFunction()
  }

  logoutFunction(): void {
    window.location.href = "/"
  }
}
